import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import WhatsAppCategoryMiniTable from './WhatsAppCategoryMiniTable';

/**
 * WhatsAppCategoryBreakdown - Card "Envios por tipo de mensagem" com o total da plataforma no
 * período (overview.php > categories/sends_by_category), entre os cards de KPI e a tabela de
 * empresas (Admin Geral > WhatsApp).
 * @param {Object} props
 * @param {Array<{key: string, label: string}>} props.categories
 * @param {Object} props.sendsByCategory - { [key]: { platform, own, total } }
 * @param {number} props.days
 * @param {boolean} props.isLoading
 */
function WhatsAppCategoryBreakdown({ categories = [], sendsByCategory = {}, days, isLoading = false }) {
  return (
    <Card
      sx={{
        borderRadius: '12px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
        border: '1px solid #E8ECF0',
        p: '20px',
        mb: 3,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: '10px',
            bgcolor: 'rgba(90, 128, 251, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <CategoryOutlinedIcon sx={{ color: '#5A80FB', fontSize: 20 }} />
        </Box>
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>Envios por tipo de mensagem</Typography>
          <Typography variant="body2" color="text.secondary">
            últimos {days} dias
          </Typography>
        </Box>
      </Box>

      {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress size={28} />
        </Box>
      ) : (
        <WhatsAppCategoryMiniTable
          categories={categories}
          byCategory={sendsByCategory}
          emptyMessage="Nenhum envio no período."
          showShare
        />
      )}
    </Card>
  );
}

export default WhatsAppCategoryBreakdown;
